import { connect, MapDispatchToPropsFunction } from 'react-redux'
import { State } from 'interfaces/state'
import App, { AppStateProps, AppDispatchProps, AppOwnProps } from 'components/features/pfm/App/App'
import { pageChangedActionCreator, setUnexpectedErrorActionCreator } from 'actions/globalActions'
import { errorTypeSelector, isAuthenticatedSelector } from 'selectors/globalSelectors'
import { withRouter } from 'react-router-dom'
import { setupFlushDateActionCreator } from 'actions/flushDateActions'
import { fetchCTAFromURLActionCreator } from 'actions/insightsActions'

const mapStateToProps = (state: State, ownProps: AppOwnProps): AppStateProps => {
  return {
    isAuthenticated: Boolean(isAuthenticatedSelector(state)),
    hasError: Boolean(errorTypeSelector(state, ownProps)),
    isDataUpdated: state.data.flushDate.isFlushed,
  }
}


const mapDispatchToProps: MapDispatchToPropsFunction<
  AppDispatchProps,
  AppOwnProps
> = (dispatch) => ({
  sendPageChanged: (payload) => dispatch(pageChangedActionCreator(payload)),
  setApplicationError: (error) => dispatch(setUnexpectedErrorActionCreator('runtime-error', error)),
  setupFlushDate: () => dispatch(setupFlushDateActionCreator()),
  fetchCTA: () => dispatch(fetchCTAFromURLActionCreator()),
})

const AppContainerInner = connect<AppStateProps, AppDispatchProps, AppOwnProps>(mapStateToProps, mapDispatchToProps)(App)
const AppContainer = withRouter(AppContainerInner)
export default AppContainer
